import API from "@utils/request";
let Language = localStorage.getItem('currentLanguage');  //获取本地语言
let prout = 'protal';
if (!Language || Language == 'zh') {
    prout = 'protal';
} else {
    prout = 'protal_' + Language;
}
// 话题-列表

export async function getTopicList(params) {
    try {
        return await API.post("/api/" + prout + "/api/topic/topicList", params);
    } catch (error) {
        return error;
    }
}


// 话题文章-列表

export async function getTopicArticleList(params) {
    try {
        return await API.post("/api/" + prout + "/api/topic/articleList", params);
    } catch (error) {
        return error;
    }
}
// 话题更多活动-列表

export async function getTopicActivityList(params) {
    try {
        return await API.post("/api/" + prout + "/api/topic/topicActivityList", params);
    } catch (error) {
        return error;
    }
}
// 话题主持人-列表

export async function getTopicHostList(params) {
    try {
        return await API.post("/api/" + prout + "/api/host/list", params);
    } catch (error) {
        return error;
    }
}

// 话题文章详情

export async function getTopicArticleInfo(params) {
    try {
        return await API.post("/api/" + prout + "/api/topic/articleInfo", params);
    } catch (error) {
        return error;
    }
}
// 话题文章详情-相关文章

export async function getTopicArticleInfoRelationList(params) {
    try {
        return await API.post("/api/" + prout + "/api/topic/articleInfoRelationList", params);
    } catch (error) {
        return error;
    }
}



// 话题文章收藏
export async function setTopicArticleCollection(params) {
    try {
        return await API.post("/api/" + prout + "/api/topic/collection", params);
    } catch (error) {
        return error;
    }
}
// 话题文章点赞
export async function setTopicArticleLike(params) {
    try {
        return await API.post("/api/" + prout + "/api/topic/like", params);
    } catch (error) {
        return error;
    }
}
// 分享得分
export async function sharePoints(params) {
    try {
        return await API.post("/api/" + prout + "/api/topic/sharePoints", params);
    } catch (error) {
        return error;
    }
}
// 获取评论列表
export async function ansList(params) {
    try {
        return await API.post("/api/" + prout + "/api/topic/ansList", params);
    } catch (error) {
        return error;
    }
}


//回复
export async function setTopicAnsAdd(params) {
    try {
        return await API.post("/api/" + prout + "/api/article_ans/add", params);
    } catch (error) {
        return error;
    }
}
//回复-删除
export async function setTopicAnsDel(params) {
    try {
        return await API.post("/api/" + prout + "/api/article_ans/delete", params);
    } catch (error) {
        return error;
    }
}
//回复-点赞
export async function setTopicAnsLike(params) {
    try {
        return await API.post("/api/" + prout + "/api/article_ans/like", params);
    } catch (error) {
        return error;
    }
}
//回复-采纳
export async function setTopicAnsAdopt(params) {
    try {
        return await API.post("/api/" + prout + "/api/article_ans/adopt", params);
    } catch (error) {
        return error;
    }
}
//回复-置精华
export async function setTopicAnsSetEssence(params) {
    try {
        return await API.post("/api/" + prout + "/api/article_ans/setEssence", params);
    } catch (error) {
        return error;
    }
}